import styled, { css } from 'styled-components';
import { media } from '@prisjakt/ui-base';
import PriceLabelComponent from '@prisjakt/ui-price-label';
import { Align } from '../../../../types';

type PriceColumnProps = {
  align?: Align;
};

export const PriceColumn = styled.div<PriceColumnProps>`
  display: flex;
  white-space: nowrap;
  align-items: baseline;
  margin-left: 0.5rem;
  ${p =>
    p.align === 'right' &&
    css`
      text-align: right;
    `}
`;

export const ShippingLabelWrapper = styled.div`
  margin-right: 0.5em;
  ${media.smallOnly`
      display:none;
    `}
`;

export const Hidden = styled.span`
  display: none;
`;

const priceSize = '16px';

export const PriceLabel = styled(PriceLabelComponent)`
  font-size: ${priceSize};
  text-align: right;
  line-height: 24px;
`;

export const ShippingLabelPlaceholder = styled.div`
  height: 18px;
  width: 1px;
`;
